import { createValidator, stringLength, stringTrim,combineValidators } from 'app/validators/base'
import i18next from 'i18next'
import { getInnerTextFromHtmlString } from 'helpers/common'


const validate = combineValidators([
  value => {
    if (value && value.length > 2000) {
      return {
        isValid: false,
        message: i18next.t('admin:total characters number must be less than', { max: 2000 }),
      }
    }},
    stringLength({ min: 1, max: 400 }, (value) =>  stringTrim(getInnerTextFromHtmlString(value))),
])

export default createValidator(validate, 'description')
